module.exports = __webpack_public_path__ + "static/item--blinds--f1@3x.8cdb7b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--blinds--f1@3x.png
// module id = 628
// module chunks = 126511778744290